import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SmartDeviceLog {
  id: string;
  smart_device_id: string;
  booking_id: string | null;
  action_type: 'turn_off' | 'turn_on' | 'skip_turn_off';
  success: boolean;
  response_status: number | null;
  response_message: string | null;
  error_message: string | null;
  next_booking_within_50min: boolean | null;
  created_at: string;
  bookings?: {
    booking_number: string;
    customer_name: string;
  } | null;
}

export const useSmartDeviceLogs = (deviceId: string) => {
  return useQuery({
    queryKey: ['smart_device_logs', deviceId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('smart_device_logs')
        .select(`
          *,
          bookings (
            booking_number,
            customer_name
          )
        `)
        .eq('smart_device_id', deviceId)
        .order('created_at', { ascending: false })
        .limit(50);

      if (error) throw error;
      return data as SmartDeviceLog[];
    },
    refetchInterval: 30000, // Refetch every 30 seconds
  });
};
